export default "__VITE_ASSET__CZSPhaLE__"